<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/VAK2ab/images/9781439677933.jpg?1737821500314" alt="This image is the cover for the book Ghostly Tales of the Jersey Shore, Spooky America"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Ghostly Tales of the Jersey Shore, Spooky America
      </h1>
      <p class="bookDescription body article font2">
        <p>Ghost stories from down the shore have never been so creepy, fun, and full of mystery! <br/> Welcome to the spooky Jersey Shore!    Stay alert! Ghosts lurk around every corner. Even the most unexpected places might be haunted by wandering phantoms. <br/> Did you know that many of the Jersey Shore's famous lighthouses are haunted? Or that restless ghosts from the past wander these moonlit shores? Can you believe musical apparitions may be rocking--and  haunting --the Convention Hall in Asbury Park? <br/> Pulled right from history, these ghostly tales will change the way you see the Jersey Shore and have you sleeping with the light on!</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Patricia Heyer
      </h2>
      
      <p class="authorDescription body article">Patricia Heyer is a local history buff with a special interest in New Jersey folklore and marine science. She has written extensively for both children and adults during her career. Her most recent title,  Haunted Jersey Shore Beaches, Boardwalks, and Lighthouse  was released in 2022. Pat is an avid reader, beachcomber, and animal rescue supporter. She resides on the Jersey shore with her husband Rob and their rescue cat, Gracie.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Arcadia Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?eceaf200